import { fork, all } from "redux-saga/effects"

import usersSaga from "./users"
import userRolesSaga from "./userRoles"
import customersSaga from "./customers"
import bundlesSaga from "./bundles"
import updatesSaga from "./updates"
import loansSaga from "./loans"
import batchesSaga from "./batches"
import settingsSaga from "./settings"
import organizationsSaga from "./organizations"
import businessSaga from "./business"
import chargesSaga from "./charges"
import AccountingsSaga from "./accounting"
import FinanciersSaga from "./financiers"
import NotificationsSaga from "./notifications"

function* rootSaga() {
  yield all([
    fork(usersSaga),
    fork(userRolesSaga),
    fork(customersSaga),
    fork(bundlesSaga),
    fork(updatesSaga),
    fork(loansSaga),
    fork(batchesSaga),
    fork(settingsSaga),
    fork(organizationsSaga),
    fork(businessSaga),
    fork(chargesSaga),
    fork(AccountingsSaga),
    fork(FinanciersSaga),
    fork(NotificationsSaga),
  ])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/index.js